import { render } from "./AdminLicences.vue?vue&type=template&id=f46c3140&scoped=true"
import script from "./AdminLicences.vue?vue&type=script&lang=js"
export * from "./AdminLicences.vue?vue&type=script&lang=js"

import "./AdminLicences.vue?vue&type=style&index=0&id=f46c3140&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f46c3140"]])

export default __exports__